/**
 * Shared pixel dimensions for marker/overlay layout — the single source of
 * truth both `adapters/osm` and `adapters/google` build their icons from
 * (see `buildMarkerNode.tsx`), so the two providers can never visually
 * drift apart over one being tweaked and not the other.
 */
export const PIN_SIZE: [number, number] = [34, 37]; // matches the BaseMarker spec SVG's viewBox
export const DRIVER_SIZE: [number, number] = [48, 48];
export const ETA_BLOCK_HEIGHT = 40;
export const ETA_BLOCK_WIDTH = 168;

export type IconAnchorStyle = "bottom-center" | "center";
